import { Site, Viewer } from "@equiem/web-ng-lib";
import { useContext, useEffect, useState } from "react";
import ReactVisibilitySensor from "react-visibility-sensor";
import { DataType, PageViewPageType, useMetricMutation } from "../../generated/gateway-client";

interface Props {
  contentUuid: string;
  contentType: PageViewPageType;
  contentTitle: string;
  categories?: string[];
}

export const CortexContentEndMetric: React.FC<Props> = ({
  contentUuid,
  contentType,
  contentTitle,
  categories,
}) => {
  const [endOfContentReachCounter, setEndOfContentReachCounter] = useState(0);
  const site = useContext(Site);
  const user = useContext(Viewer);
  const [metricMutation] = useMetricMutation();

  useEffect(() => {
    if (endOfContentReachCounter !== 1) {
      return;
    }

    const sanitizedCategories = categories
      ?.map((cat) => cat.replace(",", ""))
      .join(",") ?? null;

    metricMutation({
      variables: {
        input: {
          ME: "content_end",
          AI: "web",
          PI: site.uuid,
          DT: DataType.Count,
          TS: new Date().getTime(),
          VL: 1,
          TR: contentUuid,
          TT: contentType.toLowerCase(),
          TD: contentTitle,
          TC: sanitizedCategories,
          UI: user?.uuid,
          V: 9,
        },
      },
    }).catch(() => {
      console.log("content end metric send failed");
    });
  }, [endOfContentReachCounter])

  const onReachingContentEnd = (isVisible: boolean) => {
    if (isVisible) {
      setEndOfContentReachCounter(endOfContentReachCounter + 1);
    }
  }

  // tslint:disable:no-unsafe-any
  return (
    <ReactVisibilitySensor delayedCall={true} onChange={onReachingContentEnd}>
      <div className="content-end-marker" style={{ height: "1px", width: "1px" }}></div>
    </ReactVisibilitySensor>
  );
  // tslint:enable:no-unsafe-any
}
